import React, { useContext, useEffect, useState } from 'react';
import Modal from 'react-responsive-modal';
import {
	Button,
	Form,
	FormGroup,
	Label,
	Col,
} from 'reactstrap';
// import Datepicker from 'react-datepicker';
import Select from 'react-select';
import Datetime from 'react-datetime';
import { Link } from 'react-router-dom';
import NumberFormat from 'react-number-format';
import { DESA, Get, JENIS_DESA, JENIS_DUSUN, KECAMATAN, Nama_DESA, NAMA_KABUPATEN, Post, PROVINSI } from '../../function/Koneksi';
import { Tanggal } from '../../function/Format';
import { generateAlamat } from '../../function/Format';

const ModalSuratTidakMampu = ({ data, optionData, setAlert, isOpen, setIsOpen, statusRefresh, setStatusRefresh, propsData, kiosk }) => {
	const dateFormat = require('dateformat');

	const formOrangTua = {
		nik: "",
		nama: "",
		tempat_lahir: "",
		tanggal_lahir: "",
		alamat: "",
		alamat_kk: "",
	};

	const frmDex = {
		uuid: '',
		id_jenis: '',
		nik_pelapor: '',
		nik: '',
		kk: '',
		nama_pemohon: '',
		tempat_lahir: '',
		tanggal_lahir: '',
		jenis_kelamin: '',
		pekerjaan: '',
		pendidikan_terakhir: '',
		kewarganegaraan: '',
		agama: '',
		alamat: '',
		alamat_kk: '',
		status_perkawinan: '',
		tujuan_pembuatan: '',
		keterangan_tambahan: '',
		detail: [],
		orang_tua_wali:formOrangTua,
	}

	const initFormData = {
		frmNik: optionData.frmNik,
		frmNik2: optionData.frmNik2,
		frmNik3: optionData.frmNik3,
		frmShdk: optionData.frmShdk,
		tmplistPenduduk: optionData.tmplistPenduduk,
		tmplistPenduduk3: optionData.tmplistPenduduk3,
		nikStat: null,
		nik2Stat: null,
		nik3Stat: null,
		formOpsional: optionData.formOpsional,
		opsionalStat: 'tanpa_opsi',
		shdk_aw: null,
		detail: [],
		status: {
			form: false,
			btnForm: false,
			btnAksi: [],
			dataPenduduk: "none",
			dataAnggotaKeluarga: optionData.dataAnggotaKeluarga,
			dataOrangTua: optionData.dataOrangTua,
			frmDataOrangTua: optionData.frmDataOrangTua,
			frmDetailDataOrangTua: optionData.frmDetailDataOrangTua,
			frmKeteranganTambahan: optionData.frmKeteranganTambahan,
			frmPreviewDraft: false,
			jenis_form: '',
		},
		show: false,
		basicTitle: "",
		basicType: "default",
		pesanAlert: "",

		// Preview surat
		get_data_surat:[],
		get_jenis_surat: "",
	}

	const [formData, setFormData] = useState(initFormData)
	const [props, setProps] = useState(propsData)
	const [kioskMode, setKioskMode] = useState(kiosk)
	const [dt, setDt] = useState(data ? data : frmDex)
	const [draggable, setDraggable] = useState({
		isDown: false,
		startY: null,
		scrollUp: null,
	})

	useEffect(() => {
		if (document.getElementById("modalForm")) {
			document.getElementById("modalForm").reset()
		}

		// console.log('useeffect');
		// console.log(formData);
		// console.log(data);
		// console.log(optionData);
		
		
		setDt(data ? data : frmDex)
		setFormData(data ? {
			...initFormData,
			nikStat: optionData.nikStat,
			nik2Stat: optionData.nik2Stat,
			status: optionData.status,
			opsionalStat: optionData.opsionalStat,
			dataAnggotaKeluarga: optionData.dataAnggotaKeluarga,
			dataOrangTua: optionData.dataOrangTua,
			frmDataOrangTua: optionData.frmDataOrangTua,
			frmDetailDataOrangTua: optionData.frmDetailDataOrangTua,
			frmKeteranganTambahan: optionData.frmKeteranganTambahan,
		} : initFormData)
	}, [isOpen])

	const handleInputChangeNIK = (e, fld) => {
		if (e && kioskMode == false) {
			let nikStat = { value: e, label: e };

			Post("penduduk", null, { nik: e }, datanik => {
				let frmNik = [];
				let tmplistPenduduk = {}
				datanik.data.results.data.forEach(dt => {
					frmNik.push({ value: dt.id, label: dt.id + ' (' + dt.nama + ')' });
					tmplistPenduduk = {
						...tmplistPenduduk,
						[dt.id]: dt
					}
				});

				switch (fld) {
					case "nik":
						setFormData({
							...formData,
							frmNik,
							tmplistPenduduk,
							nikStat
						})
						break;

					case "nik2":
						setFormData({
							...formData,
							frmNik2: frmNik,
							nik2Stat: nikStat
						});
						break;
					default:
						break;
				}

			});

		}
	};

	const changeInputText = (e, fld) => {
		switch (fld) {
			case "nik_orang_tua":
				setDt({
					...dt,
					orang_tua_wali:{
						...dt.orang_tua_wali,
						nik: e.target.value,
					}
				})
				break;
			case "nama_orang_tua":
				setDt({
					...dt,
					orang_tua_wali:{
						...dt.orang_tua_wali,
						nama: e.target.value,
					}
				})
				break;
			case "tempat_lahir_orang_tua":
				setDt({
					...dt,
					orang_tua_wali:{
						...dt.orang_tua_wali,
						tempat_lahir: e.target.value,
					}
				})
				break;
			case "alamat_orang_tua":
				setDt({
					...dt,
					orang_tua_wali:{
						...dt.orang_tua_wali,
						alamat: e.target.value,
					}
				})
				break;
			case "alamat_orang_tua_kk":
				setDt({
					...dt,
					orang_tua_wali:{
						...dt.orang_tua_wali,
						alamat_kk: e.target.value,
					}
				})
				break;
			case "keterangan_tambahan":
				setDt({
					...dt,
					keterangan_tambahan: e.target.value,
				})
				break;
			default:
				// no default
				break;
		}
	};

	const gantiTgl = (date, fld) => {
		switch (fld) {
			case "tanggal_lahir":
				if (typeof date._isValid !== 'undefined') {
					let tgl = date.format('YYYY-MM-DD');
					setDt({
						...dt,
						orang_tua_wali: {
							...dt.orang_tua_wali,
							tanggal_lahir: new Date(tgl),
						},
					})
				}
				break;
			default:
				// no default
				break;
		}
	};

	const getPenduduk = (e, sel, jns) => {
		if (e) {
			if (kioskMode) {
				props.setLoadingPreview(true)
			}
			else{
				setAlert({
					loadingPreview: true
				})
			}
			
			Get("penduduk/find", e.value, data => {
				if(data.results){
					const alamat = generateAlamat(data.results);
					let alamat_kk = "";
				
					if(data.results.data_kk){
					  alamat_kk = data.results.data_kk.alamat
					}

					if (jns === "pelapor") {
						if (kioskMode === false) {
							Get("penduduk/kk/"+data.results.id_kk, null, dtkk => {
								let frmNik3 = [];
								let tmplistPenduduk3 = {};
								dtkk.results.forEach(val => {
									frmNik3.push({ value: val.id, label: val.id + ' (' + val.nama + ')' });
									tmplistPenduduk3 = {
										...tmplistPenduduk3,
										[val.id]: val
									}
								});

								// New set alamat
								let alamat = data.results.alamat;
								const dataKK = data.results.data_kk
								const dataDesa = data.results.data_keldes
								const dataKecamatan = dataDesa.data_kecamatan
								const dataKabkota = dataKecamatan.data_kabkota
								const dataProvinsi = dataKabkota.data_provinsi

								if (JENIS_DESA.toLowerCase() !== 'kelurahan') {
									if (dataKK.data_rt) {
										const dataRT = dataKK.data_rt
										const dataRW = dataRT.data_rw
										const dataDusun = dataRW.data_dusun ? dataRW.data_dusun : {nama: '-'}

										// Jika tidak ada RT
										if (dataRT.id === '0') {
											alamat = `${JENIS_DUSUN} ${dataDusun.nama}, ${JENIS_DESA} ${dataDesa.nama}, Kecamatan ${dataKecamatan.nama}, ${dataKabkota.nama}, ${dataProvinsi.nama}`
										} else {
											alamat = `RT. ${dataRT.nama}/RW. ${dataRW.nama}, ${JENIS_DUSUN} ${dataDusun.nama}, ${JENIS_DESA} ${dataDesa.nama}, Kecamatan ${dataKecamatan.nama}, ${dataKabkota.nama}, ${dataProvinsi.nama}`
										}
									}
								} else { // Jika kelurahan tanpa dusun
									if (dataKK.data_rt) {
										const dataRT = dataKK.data_rt
										const dataRW = dataRT.data_rw

										alamat = `RT. ${dataRT.nama}/RW. ${dataRW.nama}, ${JENIS_DESA} ${dataDesa.nama}, Kecamatan ${dataKecamatan.nama}, ${dataKabkota.nama}, ${dataProvinsi.nama}`
									}
								}
			
								setFormData({
									...formData,
									nikStat: e,
									frmNik3,
									tmplistPenduduk3,
									status: {
										...formData.status,
										dataPenduduk: "block",
									},
								})
								setDt({
									...dt,
									nik: data.results.id,
									nik_pelapor: data.results.id,
									kk: data.results.id_kk,
									nama_pemohon: data.results.nama,
									tempat_lahir: data.results.tempat_lahir,
									tanggal_lahir: new Date(
										data.results.tanggal_lahir
									),
									pekerjaan: data.results.data_pekerjaan.nama,
									pendidikan_terakhir: data.results.data_pendidikan_terakhir.nama,
									agama: data.results.data_agama.nama,
									status_perkawinan: data.results.status_perkawinan,
									jenis_kelamin: data.results.jk,
									alamat: alamat,
									alamat_kk: alamat_kk,
									kewarganegaraan: 'Indonesia',
									detail: []
								})

								if (kioskMode) {
									props.setLoadingPreview(false);
								}
								setAlert({
									loadingPreview: false
								})
							})
						} else { // Jika mode kiosk langsung set tanpa get list kk keluarga krna sudah ada
							setFormData({
								...formData,
								nikStat: e,
								status: {
									...formData.status,
									dataPenduduk: "block",
								},
							})
							setDt({
								...dt,
								nik: data.results.id,
								nik_pelapor: data.results.id,
								kk: data.results.id_kk,
								nama_pemohon: data.results.nama,
								tempat_lahir: data.results.tempat_lahir,
								tanggal_lahir: new Date(
									data.results.tanggal_lahir
								),
								pekerjaan: data.results.data_pekerjaan.nama,
								pendidikan_terakhir: data.results.data_pendidikan_terakhir.nama,
								agama: data.results.data_agama.nama,
								status_perkawinan: data.results.status_perkawinan,
								jenis_kelamin: data.results.jk,
								alamat:alamat,
								alamat_kk:alamat_kk,
								kewarganegaraan: 'Indonesia',
								detail: []
							})

							if (kioskMode) {
								props.setLoadingPreview(false);
							}
							setAlert({
								loadingPreview: false
							})
						}
						
					} else if (jns === "pelapor2") {
						setFormData({
							...formData,
							nik2Stat: e,
							status: {
								...formData.status,
								dataOrangTua: "none",
								frmDetailDataOrangTua:"block",
							},
						})
						setDt({
							...dt,
							orang_tua_wali:{
								nik: e.value,
								nama: data.results.nama,
								tempat_lahir: data.results.tempat_lahir,
								tanggal_lahir: new Date(
									data.results.tanggal_lahir
								),
								alamat: alamat,
								alamat_kk: alamat_kk,
							},
						})

						if (kioskMode) {
							props.setLoadingPreview(false);
						}
						setAlert({
							loadingPreview: false
						})
					} else if (jns === "pengikut") {
						if (kioskMode === false){
							let detail = dt.detail
							detail.push({
								nik: data.results.id,
								nama: data.results.nama,
								jk: data.results.jk,
								tanggal_lahir: new Date(
									data.results.tanggal_lahir
								),
								tempat_lahir: data.results.tempat_lahir,
								pekerjaan: data.results.data_pekerjaan.nama,
								pendidikan: data.results.data_pendidikan_terakhir.nama,
								shdk: data.results.data_shdk.nama,
								alamat: alamat,
								alamat_kk: alamat_kk,
								keterangan: "",
							})
		
							setDt({
								...dt,
								detail
							})
						}
						else{
							if(formData.nikStat){
								let detail = dt.detail
								detail.push({
									nik: data.results.id,
									nama: data.results.nama,
									jk: data.results.jk,
									tanggal_lahir: new Date(
										data.results.tanggal_lahir
									),
									tempat_lahir: data.results.tempat_lahir,
									pekerjaan: data.results.data_pekerjaan.nama,
									pendidikan: data.results.data_pendidikan_terakhir.nama,
									shdk: data.results.data_shdk.nama,
									alamat: alamat,
									alamat_kk: alamat_kk,
									keterangan: "",
								})
			
								setDt({
									...dt,
									detail
								})
							}
							else{
								props.getAntrian('Surat Keterangan Tidak Mampu', 'gagal', true);
							}
							
						}
						if (kioskMode) {
							props.setLoadingPreview(false)
						}
						else{
							setAlert({
								loadingPreview: false
							})
						}
					}
				}
				else{
					if (kioskMode) {
						props.setLoadingPreview(false)
					}
					else{
						setAlert({
							loadingPreview: false
						})
					}
				}
			})

		} else {
			switch (jns) {
				case "pelapor":
					setDt({
						...dt,
						nama_pemohon: '',
						tempat_lahir: '',
						tanggal_lahir: null,
						pekerjaan: '',
						pendidikan_terakhir: '',
						agama: '',
						status_perkawinan: '',
						jenis_kelamin: '',
						alamat: '',
						alamat_kk: '',
						detail: []
					})

					if (kioskMode === false) {
						setFormData({
							...formData,
							status: {
								...formData.status,
								dataPenduduk: "none"
							},
							nikStat: null,
							frmNik3: [],
							tmplistPenduduk3: null
						})
					}
					else{
						setFormData({
							...formData,
							status: {
								...formData.status,
								dataPenduduk: "none"
							},
							nikStat: null,
						})
					}
					break;
				case "pelapor2":
					setFormData({
						...formData,
						nik2Stat: null,
						status: {
							...formData.status,
							dataOrangTua: "none",
							frmDetailDataOrangTua:"none",
						},
					})
					setDt({
						...dt,
						orang_tua_wali:formOrangTua,
					})
					break;
				case "pengikut":
					setFormData({
						...formData,
						nik3Stat: null
					})
					break;
				default:
					break;
			}
		}
	};

	const hapusDetail = (i) => {
		// console.log(i);
		// let currDetail = dt.detail
		let newDetail = dt.detail.splice(i,1)

		// console.log(currDetail);
		// console.log(newDetail);
		// console.log(dt.detail);

		setDt({
			...dt,
			detail: dt.detail
		})
  };

  	const onChangeSelect = (e, data) => {
		if (e) {
			switch (data) {
				case 'data_opsional':
					
					if (e.target.value === 'orangtua_wali') {
						// console.log('ortunya')
						setFormData({
							...formData,
							nik2Stat: null,
							opsionalStat: e.target.value,
							status: {
								...formData.status,
								frmDataOrangTua: "block",
								frmDetailDataOrangTua: "none",
								dataOrangTua: "none",
								dataAnggotaKeluarga: "none",
								frmKeteranganTambahan: "none",
							}
						})
					}
					else if (e.target.value === 'anggota_keluarga') {
						setFormData({
							...formData,
							opsionalStat: e.target.value,
							status: {
								...formData.status,
								dataAnggotaKeluarga: "block",
								frmDataOrangTua: "none",
								frmDetailDataOrangTua: "none",
								dataOrangTua: "none",
								frmKeteranganTambahan: "none",
							}
						})
					}
					else if (e.target.value === 'keterangan_lainnya') {
						setFormData({
							...formData,
							opsionalStat: e.target.value,
							status: {
								...formData.status,
								frmKeteranganTambahan: "block",
								frmDataOrangTua: "none",
								frmDetailDataOrangTua: "none",
								dataOrangTua: "none",
								dataAnggotaKeluarga: "none",
							}
						})
					}
					else {
						setFormData({
							...formData,
							opsionalStat: e.target.value,
							status: {
								...formData.status,
								frmDataOrangTua: "none",
								frmDetailDataOrangTua: "none",
								dataOrangTua: "none",
								dataAnggotaKeluarga: "none",
								frmKeteranganTambahan: "none",
							},
							nik2Stat: null,
						})
					}
					setDt({
						...dt,
						orang_tua_wali:formOrangTua,
						detail: [],
						keterangan_tambahan: '',
					})

					break;				
				default:
					// no default
					break;
			}
		} else {
			switch (data) {
				case 'data_opsional':
					setDt({
						...dt,
						orang_tua_wali: formOrangTua,
						detail: [],
						keterangan_tambahan:'',
					})
					setFormData({
						...formData,
						nik2Stat:null,
						opsionalStat: null,
						status: {
							...formData.status,
							frmDataOrangTua: "none",
							frmDetailDataOrangTua: "none",
							dataAnggotaKeluarga: "none",
							frmKeteranganTambahan: "none",
						}
					})
				break;

				default:
					// no default
					break;
			}
		}
	}


	const simpan = (e) => {
		e.preventDefault();

		if (kioskMode){
			props.setLoadingPreview(true)
		}
		else{
			setAlert({
				loadingPreview: true
			})
		}

		let validasiPelapor = formData.nikStat;
		let validasiOrangTua = false;
		let validasiKeluarga = false;
		let validasiKeteranganTambahan = false;

		let detail_surat = null

		if(formData.opsionalStat === 'orangtua_wali'){
			let nik_orang_tua = '';
			if(formData.status.dataOrangTua==="none"){
				if(formData.nik2Stat){
					validasiOrangTua = true;
					validasiKeluarga = true
					validasiKeteranganTambahan = true;
					nik_orang_tua= formData.nik2Stat.value
				}
			}
			else{
				if(dt.orang_tua_wali.nik){
					validasiOrangTua = true;
					validasiKeluarga = true
					validasiKeteranganTambahan = true;
					nik_orang_tua = dt.orang_tua_wali.nik;
				}
			}

			detail_surat = {
				orang_tua_wali:{
					nik: nik_orang_tua,
					nama: dt.orang_tua_wali.nama,
					tempat_lahir: dt.orang_tua_wali.tempat_lahir,
					tanggal_lahir: dt.orang_tua_wali.tanggal_lahir?dateFormat(new Date(dt.orang_tua_wali.tanggal_lahir), 'yyyy-mm-dd'):dt.orang_tua_wali.tanggal_lahir,
					alamat: dt.orang_tua_wali.alamat,
					alamat_kk: dt.orang_tua_wali.alamat_kk,
				}
			}
		}
		else if(formData.opsionalStat === 'anggota_keluarga'){
			if(dt.detail){
				validasiOrangTua = true;
				validasiKeluarga = true
				validasiKeteranganTambahan = true
			}
		}
		else if(formData.opsionalStat === 'keterangan_lainnya'){
			if(dt.keterangan_tambahan){
				validasiOrangTua = true;
				validasiKeluarga = true
				validasiKeteranganTambahan = true
				detail_surat = {
					keterangan_tambahan: dt.keterangan_tambahan,
				}
			}
		}
		else if(formData.opsionalStat === 'tanpa_opsi'){
			validasiOrangTua = true;
			validasiKeluarga = true
			validasiKeteranganTambahan = true;
		}
		
		if (validasiPelapor && validasiOrangTua && validasiKeluarga && validasiKeteranganTambahan) {

			let bodyRaw = {
				...dt,
				tanggal_lahir: dateFormat(new Date(dt.tanggal_lahir), 'yyyy-mm-dd'),
				tujuan_pembuatan: document.getElementById('tujuan_pembuatan').value,
				detail_surat: detail_surat?JSON.stringify(detail_surat):null,
			}
			if (dt.uuid === '') {
				if (kioskMode) {
					bodyRaw.id_jenis = props.id_jenis
				} else {
					bodyRaw.id_jenis = props.location.state.uuid
				}
			}
			
			let psn = "";
			let resstat = 204;
			let metode = "create";
			if (bodyRaw.uuid === "") {
				psn = "Tambah";
				resstat = 201;
				bodyRaw.uuid = null;
			} else {
				psn = "Ubah";
				resstat = 200;
				metode = "update";
			}
			Post(
				"surat-keterangan/tidak-mampu/" + metode,
				bodyRaw.uuid,
				bodyRaw,
				res => {

					// For testing
					if (props.resSubmit) {
						props.resSubmit(res.status)
					}
					tutupForm()
					setFormData({
						...formData,
						status: {
							...formData.status,
							btnForm: false,
							form: false,
						}
					})
					setIsOpen(false)

					if (kioskMode) {
						if (res.status === resstat) {
							let dataAntrian = {
								nama: props.data.results.nama,
								nik: props.data.results.id,
								keterangan: '',
								uuid_surat:res.data.results.uuid_surat,
								kode_surat:res.data.results.kode_surat,
							};

							// Set Data Surat
							props.getDataSurat(res.data.results);
	
							setTimeout(function () {
								Get('persetujuan/kiosk/' + dataAntrian.uuid_surat + '/' + props.id_jenis, null, (res2) => {
									
									props.setLoadingPreview(false)
									
									if (res2.code === 201) {
										props.getAntrian('Surat Keterangan Tidak Mampu', 'berhasil', false, dataAntrian);
									}
									else {
										props.getAntrian('Surat Keterangan Tidak Mampu', 'gagal');
									}
								});
							}.bind(this),1000)
						}
						else {
							props.setLoadingPreview(false)
							props.getAntrian('Surat Keterangan Tidak Mampu', 'gagal');
						}
					} else {
						if (res.status === resstat) {
							const alertData = {
								get_data_surat:{
									uuid_surat:res.data.results.uuid_surat,
									kode_surat:res.data.results.kode_surat,
								},
								status:{
									frmPreviewDraft: true,
									jenis_form: psn,
								}
								// show: true,
								// basicType: "success",
								// basicTitle: "Data Surat Keterangan Penghasilan",
								// pesanAlert: "Berhasil " + psn + " Data",
								// successAlert: true,
							}
							setAlert({
							  	loadingPreview: false
							})
							setAlert(alertData)
						} else {
							const alertData = {
								show: true,
								basicType: "danger",
								basicTitle: "Data Surat Keterangan Tidak Mampu",
								pesanAlert: "Gagal " + psn + " Data"
							}
							setAlert({
							  	loadingPreview: false
							})
							setAlert(alertData)
						}
	
						// Refresh list
						setStatusRefresh(true)
					}

				}
			);
		} else {
			if (kioskMode){
				props.getAntrian('Surat Keterangan Tidak Mampu', 'gagal', true);
				props.setLoadingPreview(false)
			}
			else{
				const alertData = {
					show: true,
					basicType: "info",
					basicTitle: "Data Belum Lengkap",
					pesanAlert: "Mohon isi seluruh data dengan benar"
				}
				setAlert({
					loadingPreview: false
				})
				setAlert(alertData)
			}
		}
	};

	const tutupForm = () =>{
		setFormData({
			...formData,
			status: {
				...formData.status,
				form: false,
				jenis_form: '',
				dataAnggotaKeluarga: "none",
				dataOrangTua: "none",
				frmDataOrangTua: "none",
				frmDetailDataOrangTua: "none",
				frmKeteranganTambahan: "none",
				opsionalStat: 'tanpa_opsi',
			},
			nikStat: null,
			nik2Stat: null,
		})
		setDt({
			...dt,
			orang_tua_wali:formOrangTua,
			detail: [],
			keterangan_tambahan: '',
		})
		setIsOpen(false)
	}
	return (
		<Modal
			classNames={{ overlay: 'card-scrollable' }}
			open={isOpen}
			onClose={() => {
				setIsOpen(false)
			}}
			closeOnEsc={false}
			closeOnOverlayClick={true}
			style={{
				maxwidth: 'unset'
			}}
		>
			<Form
				id="modalForm"
				data-testid="form-create"
				className="theme-form"
				onSubmit={simpan}
			>
				<div
					onMouseDown={(e) => {
						let slider = document.querySelector('.card-scrollable');
						setDraggable({
							isDown: true,
							startY: e.pageY - slider.offsetTop,
							scrollUp: slider.scrollTop,
						})
					}}
					onMouseLeave={() => {
						setDraggable({
							...draggable,
							isDown: false
						})
					}}
					onMouseUp={() => {
						setDraggable({
							...draggable,
							isDown: false
						})
					}}
					onMouseMove={(e) => {
						e.preventDefault();

						let slider = document.querySelector('.card-scrollable');

						if (!draggable.isDown) {
							return;
						}

						const y = e.pageY - slider.offsetTop;
						const startY = draggable.startY;
						const walk = y - startY;
						slider.scrollTop = draggable.scrollUp - walk;
					}}
				>
				<div className="modal-header">
					<h5 className="modal-title">{dt.uuid == '' ? 'Tambah' : 'Edit'} Surat Keterangan Tidak Mampu</h5>
				</div>
				<div className="modal-body">
					<p>
						Data identitas akan terisi secara otomatis saat NIK dipilih.
						Jika ada ketidak sesuaian data, silakan ubah di data master
						penduduk.
					</p>
					<input
						className="form-control"
						id="uuid"
						type="hidden"
						placeholder=""
						defaultValue={dt.uuid}
					/>
					<FormGroup className="row">
						<Label
							className="col-sm-3 col-form-label"
							htmlFor="nik"
						>
							NIK Pemohon
						</Label>
						<Col sm="9">
							<div data-testid="selectNIK">
								<Select
									inputId="nik"
									name="nik"
									classNamePrefix="select"
									onChange={e => {
										getPenduduk(e, "nik", "pelapor");
									}}
									defaultValue={formData.nikStat}
									value={formData.nikStat}
									options={formData.frmNik}
									placeholder="Pilih NIK Pemohon"
									onInputChange={e => handleInputChangeNIK(e, "nik")}
									isClearable
								/>
							</div>
						</Col>
					</FormGroup>
					<div style={{ display: formData.status.dataPenduduk }}>
						<FormGroup className="row">
							<Label
								className="col-sm-3 col-form-label"
								htmlFor="inputEmail3"
							>
								Nama Pemohon
							</Label>
							<Col sm="9">
								<input
									className="form-control"
									id="nama"
									type="text"
									placeholder="Nama Pemohon"
									value={dt.nama_pemohon}
									readOnly
									style={{ backgroundColor: "#c9d1d8" }}
									disabled
								/>
							</Col>
						</FormGroup>
						<FormGroup className="row">
							<Label
								className="col-sm-3 col-form-label"
								htmlFor="inputEmail3"
							>
								Tempat Lahir
							</Label>
							<Col sm="9">
								<input
									className="form-control"
									id="tempat_lahir"
									type="text"
									placeholder="Tempat Lahir"
									value={dt.tempat_lahir}
									readOnly
									style={{ backgroundColor: "#c9d1d8" }}
									disabled
								/>
							</Col>
						</FormGroup>
						<FormGroup className="row">
							<Label
								className="col-sm-3 col-form-label"
								htmlFor="inputEmail3"
							>
								Tanggal Lahir
							</Label>
							<Col sm="9">
								<input
									className="form-control"
									id="tanggal_lahir"
									type="text"
									placeholder="Tanggal Lahir"
									value={new Date(dt.tanggal_lahir).toLocaleDateString("id-ID")}
									readOnly
									style={{ backgroundColor: "#c9d1d8" }}
									disabled
								/>
							</Col>
						</FormGroup>
						<FormGroup className="row">
							<Label
								className="col-sm-3 col-form-label"
								htmlFor="inputEmail3"
							>
								Alamat
							</Label>
							<Col sm="9">
								<input
									className="form-control"
									id="alamat_kk"
									type="text"
									placeholder="Alamat"
									value={dt.alamat_kk}
									readOnly
									style={{ backgroundColor: "#c9d1d8" }}
									disabled
								/>
							</Col>
						</FormGroup>
						<FormGroup className="row">
							<Label
								className="col-sm-3 col-form-label"
								htmlFor="inputEmail3"
							>
								Wilayah
							</Label>
							<Col sm="9">
								<input
									className="form-control"
									id="alamat"
									type="text"
									placeholder="Alamat"
									value={dt.alamat}
									readOnly
									style={{ backgroundColor: "#c9d1d8" }}
									disabled
								/>
								<small><font color="red">* Jika data wilayah kosong, silahkan perbaiki data alamat kartu keluarga dan pastikan data lengkap terlebih dahulu</font></small>
							</Col>
						</FormGroup>
					</div>
					<FormGroup className="row">
						<Label className="col-sm-3 col-form-label" htmlFor="inputEmail3">
							Keperluan Untuk
						</Label>
						<Col sm="9">
							<input
								data-testid="tujuan pembuatan"
								name="tujuan_pembuatan"
								className="form-control"
								id="tujuan_pembuatan"
								type="text"
								placeholder="Keperluan Untuk"
								defaultValue={dt.tujuan_pembuatan}
								required
							/>
						</Col>
					</FormGroup>

					<FormGroup className="row">
						<Label className="col-sm-3 col-form-label" htmlFor="inputEmail3">
							Data Opsional
						</Label>
						<Col sm="9">
								{/* <Select
									inputId="data_opsional"
									name="data_opsional"
									classNamePrefix="data_opsional"
									onChange={e => {
										onChangeSelect(e, 'data_opsional');
									}}
									defaultValue={formData.opsionalStat}
									value={formData.opsionalStat?formData.opsionalStat.value:null}
									options={formData.formOpsional}
									placeholder="Pilih Tambahan Opsional Data"
									// onInputChange={e => handleInputChangeNIK(e, "nik")}
									isClearable
								/> */}

								<select 
									className="form-control"
									value={formData.opsionalStat} 
									onChange={e => {
										onChangeSelect(e, 'data_opsional');
									}}
								>
									{formData.formOpsional && formData.formOpsional.map((option) => (
										<option value={option.value}>{option.label}</option>
									))}
								</select>
							<small><b><font color="red">*Isi Jika Diperlukan</font></b></small>
						</Col>
					</FormGroup>

					<div style={{ display: formData.status.frmDataOrangTua }}>
						<div style={{backgroundColor:'grey',paddingTop:'15px',paddingBottom:'15px',paddingLeft:'15px',color:'white',marginBottom:'15px'}}>
							<b>Data Orang Tua/Wali</b>
						</div>
						<FormGroup className="row">
							<Label
								className="col-sm-3 col-form-label"
								htmlFor="nik"
							>
								NIK Orang Tua/Wali
							</Label>
							<Col sm="9">
								{formData.status.dataOrangTua === "none" ? (
									<div data-testid="selectNIK">
										<Select
											inputId="nik"
											classNamePrefix="select"
											onChange={e => {
												getPenduduk(e, "nik", "pelapor2");
											}}
											defaultValue={formData.nik2Stat}
											value={formData.nik2Stat}
											name="NIK"
											options={formData.frmNik2}
											placeholder="Pilih NIK Orang Tua/Wali"
											onInputChange={e => handleInputChangeNIK(e, "nik2")}
											isClearable
										/>
									</div>
								) : (
									<input
										data-testid="nik_orang_tua"
										name="nik_orang_tua"
										className="form-control"
										id="nik_orang_tua"
										type={formData.status.dataOrangTua === "none" ? "hidden" : "text"}
										pattern="\d{1,16}"
										onChange={e => changeInputText(e, "nik_orang_tua")}
										maxLength={16}
										defaultValue={dt && dt.orang_tua_wali ? dt.orang_tua_wali.nik : ''}
										value={dt && dt.orang_tua_wali ? dt.orang_tua_wali.nik : ''}
										minLength={16}
										required={formData.status.dataOrangTua === "none" ? false : true}
										placeholder="Masukkan NIK Orang Tua (16 angka)"
									/>
								)}

								<small id="emailHelp" className="form-text text-muted">
									Data NIK Orang Tua/Wali {formData.status.dataOrangTua === "none" ? "tidak" : ""}{" "}
									tersedia?{" "}
									<Button
										// to={{
										// 	pathname: props.location.pathname,
										// 	state: props.location.state
										// }}
										className="btn btn-sm"
										data-testid="btnInputManual"
										onClick={() => {
											if (formData.status.dataOrangTua === "none") {
												if (props.getJenisInput) {
													props.getJenisInput("manual")
												}
											}
											else {
												if (props.getJenisInput) {
													props.getJenisInput("auto")
												}
											}
											setDt({
												...dt,
												orang_tua_wali: formOrangTua,
											})
											setFormData({
												...formData,
												nik2Stat:null,
												status: {
													...formData.status,
													dataOrangTua: formData.status.dataOrangTua === "" ? "none" : "",
													frmDetailDataOrangTua: formData.status.dataOrangTua === "none" ? "block" : "none",
												},
											})
										}}
									>
										{" "}
										Klik disini
									</Button>
								</small>
							</Col>
						</FormGroup>

						<div style={{ display: formData.status.frmDetailDataOrangTua}}>
							<FormGroup className="row">
								<Label
									className="col-sm-3 col-form-label"
									htmlFor="inputEmail3"
								>
									Nama 
								</Label>
								<Col sm="9">
									<input
										data-testid="nama_orang_tua"
										name="nama_orang_tua"
										className="form-control"
										id="nama_orang_tua"
										type="text"
										placeholder="Nama Orang Tua"
										value={dt.orang_tua_wali?dt.orang_tua_wali.nama:''}
										readOnly={formData.status.dataOrangTua === "" ? false : true}
										required
										onChange={e => changeInputText(e, "nama_orang_tua")}

										style={formData.status.dataOrangTua === "" ? { backgroundColor: "" } : { backgroundColor: "#c9d1d8" }}
										disabled={formData.status.dataOrangTua === "" ? false : true}
									/>
								</Col>
							</FormGroup>
							<FormGroup className="row">
								<Label
									className="col-sm-3 col-form-label"
									htmlFor="inputEmail3"
								>
									Tempat Lahir 
								</Label>
								<Col sm="9">
									<input
										data-testid="tempat_lahir"
										name="tempat_lahir"
										className="form-control"
										id="tempat_lahir"
										type="text"
										placeholder="Tempat Lahir Orang Tua"
										value={dt.orang_tua_wali?dt.orang_tua_wali.tempat_lahir:''}
										onChange={e =>
											changeInputText(e, "tempat_lahir_orang_tua")
										}
										readOnly={formData.status.dataOrangTua === "" ? false : true}
										required
										style={formData.status.dataOrangTua === "" ? { backgroundColor: "" } : { backgroundColor: "#c9d1d8" }}
										disabled={formData.status.dataOrangTua === "" ? false : true}
									//   readOnly
									/>
								</Col>
							</FormGroup>
							<FormGroup className="row">
								<Label
									className="col-sm-3 col-form-label"
									htmlFor="inputEmail3"
								>
									Tanggal Lahir
								</Label>
								<Col sm="9">
									{formData.status.dataOrangTua === '' ?
										(<Datetime
											inputProps={{ "data-testid": "tanggal_lahir", placeholder: 'Tanggal Lahir', required: true }}
											inputId="tanggal_lahir"
											name="tanggal_lahir"
											locale="id-ID"
											timeFormat={false}
											dateFormat="DD/MM/yyyy"
											input={true}
											closeOnTab={true}
											closeOnSelect={true}
											initialValue={dt.orang_tua_wali?dt.orang_tua_wali.tanggal_lahir:''}
											value={dt.orang_tua_wali?dt.orang_tua_wali.tanggal_lahir:''}
											onChange={e => {
												gantiTgl(e, 'tanggal_lahir')
											}}
										/>)
										:
										(<input
											className="form-control"
											id="tanggal_lahir"
											//   type="text"
											type={formData.status.dataOrangTua === "" ? "date" : "text"}
											placeholder="Tanggal Lahir"
											// value={dt.tanggal_lahir_ayah}
											value={dateFormat(dt.orang_tua_wali?dt.orang_tua_wali.tanggal_lahir:'', 'dd/mm/yyyy')}
											//   readOnly
											readOnly={formData.status.dataOrangTua === "" ? false : true}
											required
											onChange={e =>
												changeInputText(e, "tanggal_lahir")
											}
											style={formData.status.dataOrangTua === "" ? { backgroundColor: "" } : { backgroundColor: "#c9d1d8" }}
											disabled={formData.status.dataOrangTua === "" ? false : true}
										/>)
									}
								</Col>
							</FormGroup>
							<FormGroup className="row">
								<Label
									className="col-sm-3 col-form-label"
									htmlFor="inputEmail3"
								>
									Alamat
								</Label>
								<Col sm="9">
									<input
										data-testid="alamat_kk"
										name="alamat_kk"
										className="form-control"
										id="alamat_kk"
										type="text"
										placeholder="Alamat"
										value={dt.orang_tua_wali?dt.orang_tua_wali.alamat_kk:''}
										onChange={e =>
											changeInputText(e, "alamat_orang_tua_kk")
										}
										readOnly={formData.status.dataOrangTua === "" ? false : true}
										required
										style={formData.status.dataOrangTua === "" ? { backgroundColor: "" } : { backgroundColor: "#c9d1d8" }}
										disabled={formData.status.dataOrangTua === "" ? false : true}
									/>
								</Col>
							</FormGroup>
							<FormGroup className="row">
								<Label
									className="col-sm-3 col-form-label"
									htmlFor="inputEmail3"
								>
									Wilayah
								</Label>
								<Col sm="9">
									<input
										data-testid="alamat"
										name="alamat"
										className="form-control"
										id="alamat"
										type="text"
										placeholder={"Contoh: RT. 002/RW. 001, Dusun 1, Desa "+Nama_DESA+", Kec. ABC, Kab. ABC"}
										value={dt.orang_tua_wali?dt.orang_tua_wali.alamat:''}
										onChange={e =>
											changeInputText(e, "alamat_orang_tua")
										}
										readOnly={formData.status.dataOrangTua === "" ? false : true}
										required
										style={formData.status.dataOrangTua === "" ? { backgroundColor: "" } : { backgroundColor: "#c9d1d8" }}
										disabled={formData.status.dataOrangTua === "" ? false : true}
									/>
								</Col>
							</FormGroup>
						</div>
					</div>

					<div style={{ display: formData.status.dataAnggotaKeluarga }}>
						<div style={{backgroundColor:'grey',paddingTop:'15px',paddingBottom:'15px',paddingLeft:'15px',color:'white',marginBottom:'15px'}}>
							<b>Data Anggota Keluarga</b>
						</div>
						<FormGroup className="row">
							<Label className="col-sm-3 col-form-label">
								Tambah Keluarga Yang Ikut (Jika ada)
							</Label>
							<Col sm="9">
								<div data-testid="selectNIK3">
									<Select
										inputId="nik3"
										classNamePrefix="select"
										onChange={e => {
											// this.changeSelectValue(e, "nik3");
											getPenduduk(e, "nik", "pengikut");
										}}
										defaultValue={formData.nik3Stat}
										value={formData.nik3Stat}
										name="NIK3"
										options={formData.frmNik3}
										placeholder="Pilih Anggota Keluarga"
										// onInputChange={e => this.handleInputChangeNIK(e, "nik3")}
										isClearable
									/>
								</div>
							</Col>
							{dt.detail && dt.detail.length > 0 ? (
								<Col sm="12">
									<table className="table table-bordered table-stripes table-hovered">
										<thead>
											<tr>
												<th>No</th>
												<th>Nama</th>
												<th>JK</th>
												<th>Tempat/Tanggal Lahir</th>
												<th>Pekerjaan</th>
												<th>Pendidikan</th>
												<th>Hubungan Keluarga</th>
												<th>
													<i className="fa fa-trash"></i>
												</th>
											</tr>
										</thead>
										<tbody>
											{dt.detail.map((val, i) => {
												let jk = "L";
												if (val.jk === "Perempuan") {
													jk = "P";
												}
												return (
													<tr key={i}>
														<td>{i+1}</td>
														<td>{val.nama}</td>
														<td>{jk}</td>
														<td>
															{val.tempat_lahir}, {Tanggal(val.tanggal_lahir)}
														</td>
														<td>{val.pekerjaan}</td>
														<td>{val.pendidikan}</td>
														<td>{val.shdk}</td>
														<td>
															<Button
																size="xs"
																onClick={() => hapusDetail(i)}
																color="danger"
																className="btn-icon"
															>
																<i className="fa fa-trash"></i>
															</Button>
														</td>
													</tr>
												);
											})}
										</tbody>
									</table>
								</Col>
							) : ''}

						</FormGroup>
					</div>


					<div style={{ display: formData.status.frmKeteranganTambahan }}>
						<div style={{backgroundColor:'grey',paddingTop:'15px',paddingBottom:'15px',paddingLeft:'15px',color:'white',marginBottom:'15px'}}>
							<b>Data Keterangan Surat Tambahan</b>
						</div>
						<FormGroup className="row">
							<Label
								className="col-sm-3 col-form-label"
								htmlFor="inputEmail3"
							>
								Keterangan Lainnya
							</Label>
							<Col sm="9">
								<textarea
									className="form-control"
									id="keterangan_tambahan"
									type="text"
									rows={5}
									onChange={e =>
										changeInputText(e, "keterangan_tambahan")
									}
									placeholder={"Tambahkan Keterangan Surat Lainnya"}
									defaultValue={dt.keterangan_tambahan ? dt.keterangan_tambahan : ''}
									required={formData.status.frmKeteranganTambahan === "block" ? true : false}
								/>
							</Col>
						</FormGroup>
					</div>
				</div>
				<div className="modal-footer">
					<button
						type="button"
						className="btn btn-warning"
						onClick={() => {
							tutupForm()
						}}
					>
						Tutup
					</button>
					<button
						data-testid="btnSubmitCreate"
						type="submit"
						className="btn btn-primary-custom"
						disabled={formData.status.btnForm}
					>
						Simpan
					</button>
				</div>
				</div>
			</Form>
		</Modal>
	);
}

export default ModalSuratTidakMampu;
